import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';

import { TBillingCountryPack } from './types';

export function useBillingCountryPacks() {
  const { data, error, isLoading, mutate } = useSWR<TBillingCountryPack[]>(
    'commenda-billing/catalog/packs',
    SWRFetcher({ method: 'GET' })
  );

  return { packs: data ?? [], error, isLoading, mutate };
}
